export default __webpack_public_path__ + "static/media/rsz_1sidebar-4.9dbb4d0c.jpg";